module.exports = __webpack_public_path__ + "static/media/leave-icon.f99ff114.svg";